"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClockIcon = function ClockIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 256 256"
  }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M128 256C57.42 256 0 198.58 0 128S57.42 0 128 0s128 57.42 128 128-57.42 128-128 128zm0-232C70.65 24 24 70.65 24 128s46.65 104 104 104 104-46.65 104-104S185.35 24 128 24z"
  }), _react.default.createElement("path", {
    d: "M184 140h-56c-6.63 0-12-5.37-12-12V72c0-6.63 5.37-12 12-12s12 5.37 12 12v44h44c6.63 0 12 5.37 12 12s-5.37 12-12 12z"
  })));
};

ClockIcon.displayName = 'ClockIcon';
ClockIcon.propTypes = {
  size: _propTypes.number
};
ClockIcon.defaultProps = {
  size: 40
};
var _default = ClockIcon;
exports.default = _default;